module.exports = __webpack_public_path__ + "img/img2.9657f838.png";